<template>
  <div class="login-form">
    Logging Out...
  </div>
</template>

<script>

import {auth} from "@/firebaseConfig";

export default {
  name: 'logout',
  data() {
    return {}
  },
  created () {
    let self = this;
    self.$store.dispatch('setCurrentUser', null);
    auth.signOut().then(() => {
      self.$router.push(`/${self.$i18n.locale}/admin/login`);
    });
  }
}
</script>